import { createApiSlice } from "@common/common-slice/commonSlice";

import {
  CRUD_SKILL,
  GENERATE_SKILL,
  GET_SKILL,
  STORE_GENERATED_SKILL,
} from "@routes";

const apiConfig = [
  {
    name: "createSkill",
    method: "post",
    url: CRUD_SKILL,
    stateKey: "message",
  },
  {
    name: "generateSkills",
    method: "post",
    url: GENERATE_SKILL,
    stateKey: "generatedData",
    loadingKey: "genLoading",
  },
  {
    name: "storeGeneratedSkills",
    method: "post",
    url: STORE_GENERATED_SKILL,
    stateKey: "message",
  },
  {
    name: "getSkill",
    method: "get",
    url: CRUD_SKILL,
    stateKey: "data",
  },
  {
    name: "getSkillDetails",
    method: "get",
    url: GET_SKILL,
    stateKey: "detailsData",
  },
  {
    name: "updateSkill",
    method: "put",
    url: CRUD_SKILL,
    stateKey: "message",
  },
  {
    name: "deleteSkill",
    method: "delete",
    url: CRUD_SKILL,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    genLoading: false,
    backlogLoading: false,
    detailsData: [],
    generatedData: [],
    selectedSkillData: {},
  },

  reducers: {
    skillSelect: (state, action) => {
      state.selectedSkillData = action?.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "skill",
  apiConfig,
  customReducers,
);

const skillSlice = slice;

export default skillSlice.reducer;

export const {
  createSkill,
  generateSkills,
  storeGeneratedSkills,
  getSkill,
  getSkillDetails,
  updateSkill,
  deleteSkill,
} = thunks;

export const {
  rowSelect,
  skillSelect,
} = actions;
